<section id="terms-conditions-page">
    <div class="terms-conditions-page-title">
        <h3>{{'TERMS-CONDITIONS.TEXT' | translate}}</h3>
    </div>
    <div class="terms-content">
        <section id="text" class="container"> <span
                [innerHTML]="'terms-conditions-translate' | translate: {entityAddress: entityData.address, entityName: entityData.name, entityEmail: entityData.email, entitySite: siteUrl}"></span>
        </section>
    </div>
</section>
